/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2013-2023 Photon Storm Ltd.
 * @license      {@link https://opensource.org/licenses/MIT|MIT License}
 */

/**
 * @namespace Phaser.Math.Pow2
 */

module.exports = {

    GetNext: require('./GetPowerOfTwo'),
    IsSize: require('./IsSizePowerOfTwo'),
    IsValue: require('./IsValuePowerOfTwo')

};
